import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { SingleUrlInput } from '../../Shared/SingleUrlInput/SingleUrlInput';
import { Button } from '@/Domain/components/Shared/Button/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/Domain/components/Shared/Dialog/Dialog';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/Domain/components/Shared/Form/Form';
import { useUploadYoutubeForm } from '@/Domain/hooks/KnowledgeBase/useUploadYoutubeForm/useUploadYoutubeForm.hook';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const UploadYoutubeModal = () => {
  const { t } = useTranslation('knowledge_base', { keyPrefix: 'modals.upload_video.youtube' });
  const { isOpen, closeModal } = useModalStore();

  const { form, handleSubmit } = useUploadYoutubeForm();
  const handleNeedHelp = () => window.open('https://docs.quickchat.ai/', '_blank');

  return (
    <Dialog open={isOpen(MODAL_NAMES.UPLOAD_YOUTUBE_MODAL_ID)} onOpenChange={closeModal}>
      <DialogContent className="w-lg">
        <div data-testid="upload-youtube-modal">
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(handleSubmit)}
              autoComplete="off"
              className="space-y-4"
            >
              <DialogHeader>
                <DialogTitle>{t('title')}</DialogTitle>
                <DialogDescription>{t('description')}</DialogDescription>
              </DialogHeader>
              <FormField
                name="url"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <div data-testid="upload-youtube-modal-url-input">
                        <SingleUrlInput placeholder={t('url_placeholder')} {...field} />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <DialogFooter className="flex flex-row !justify-between items-center">
                <Button variant="link" onClick={handleNeedHelp} className="!pl-0">
                  <Icon icon="mingcute:question-line" className="size-5 text-muted-foreground  " />
                  <span className="!text-muted-foreground text-sm">{t('button.need_help')}</span>
                </Button>

                <div className="flex gap-2">
                  <Button variant="secondary" onClick={closeModal} type="button">
                    {t('button.cancel')}
                  </Button>

                  <Button
                    onClick={form.handleSubmit(handleSubmit)}
                    data-testid="upload-youtube-modal-submit-button"
                  >
                    {t('button.submit')}
                  </Button>
                </div>
              </DialogFooter>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  );
};
